import { useState, useEffect, useCallback, memo } from "react";
import { ArrowUp } from "lucide-react";

const FloatingButtons = memo(() => {
  const [showButtons, setShowButtons] = useState(false);

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;
    const threshold = window.innerHeight * 0.2;
    setShowButtons(currentScrollY > threshold);
  }, []);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    
    const throttledHandleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleScroll, 100);
    };

    window.addEventListener("scroll", throttledHandleScroll, { passive: true });
    
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
      clearTimeout(timeoutId);
    };
  }, [handleScroll]);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);


  if (!showButtons) return null;

  return (
    <button
      onClick={scrollToTop}
      className="floating-button fixed z-[9999] bg-garage-blue hover:bg-blue-600 text-white rounded-full shadow-lg transition-all duration-200 flex items-center justify-center touch-manipulation"
      style={{ 
        bottom: "20px",
        right: "20px",
        width: "56px",
        height: "56px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)"
      }}
      aria-label="Przewiń do góry"
      role="button"
    >
      <ArrowUp className="h-6 w-6" aria-hidden="true" />
    </button>
  );
});

export default FloatingButtons;
